module.exports = {
      id: "icon-transfer-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#icon-transfer",
      toString: function () {
        return this.url;
      }
    }